import { motion, AnimatePresence } from 'motion/react';
import styled from 'styled-components';
import { memo } from 'react';

const StyledDiv = styled(motion.div)`
	min-height: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	> * {
		flex: 1 0 auto;
	}
`;

const variants = {
	sidebarOpen: {
		transition: { staggerChildren: 0.05, delayChildren: 0.17 },
		opacity: 1,
		x: 0
	},
	sidebarClosed: ({ direction }) => {
		return {
			transition: { staggerChildren: 0.025, staggerDirection: -1 },
			x: direction >= 0 ? 300 : -300,
			opacity: 0
		};
	},
	exit: ({ direction }) => {
		return {
			transition: { staggerChildren: 0.025, staggerDirection: -1 },
			x: direction >= 0 ? -300 : 300,
			opacity: 0
		};
	}
};

const transition = {
	x: { type: 'spring', stiffness: 300, damping: 30 },
	opacity: { duration: 0.2 }
};

const AnimatedSlider = ({ direction = 0, disableTransition = false, name, children = null }) => {
	if (disableTransition) {
		return children;
	}

	return (
		<AnimatePresence initial={false} custom={{ direction }} mode="wait">
			<StyledDiv
				key={name}
				custom={{ direction }}
				variants={variants}
				initial="sidebarClosed"
				animate="sidebarOpen"
				exit="exit"
				transition={transition}
			>
				{children}
			</StyledDiv>
		</AnimatePresence>
	);
};

export default memo(AnimatedSlider);
